import ballot from "./ballot.svg";
import community from "./community.svg";
import measure from "./measure.svg";
import pedestrian from "./pedestrian.svg";
import discord from "./discord.svg";
import twitter from "./twitter.svg";
import piggyBank from "./piggyBank.svg";
import speakerCone from "./speakerCone.svg";
import anonNoun from "./anonNoun.svg";
import expand from "./expand.svg";
import walletConnected from "./walletConnected.svg";
import wallet from "./wallet.svg";
import spinner from "./spinner.svg";
import power from "./power.svg";

export const icons = {
  expand,
  anonNoun,
  speakerCone,
  piggyBank,
  discord,
  twitter,
  ballot,
  community,
  measure,
  pedestrian,
  walletConnected,
  wallet,
  spinner,
  power,
};
